import Accordion from './Accordion';

export { Accordion };
const styleSheet = () => ({
  rootAccordion: {
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || '100%',
  },
  accordionSection: {
    marginLeft: (props: any) =>
      (props.overrideStyles && props.overrideStyles.marginLeft) || '0px',
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || '100%',
  },
  accordionTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rootAccordionTitleContainer: {
    display: 'flex',
    position: 'relative',
    height: '46px',
    alignItems: 'center',
    cursor: 'pointer',
    flexGrow: 1,
  },
  accordionSectionTitleContainer: {
    display: 'flex',
    position: 'relative',
    height: '32px',
    alignItems: 'center',
    cursor: 'pointer',
    flexGrow: 1,
  },
  rootAccordionTitle: {
    textTransform: 'uppercase',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '16px',
    width: '100%',
  },
  accordionSectionTitle: {
    marginLeft: '22px',
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '16px',
    width: '100%',
  },
  accordionSectionTitleActive: {
    color: '#051D39',
  },
  rootAccordionIndicatorContainer: {
    position: 'absolute',
    right: '0px',
  },
  accordionSectionIndicatorContainer: {
    position: 'absolute',
    left: '0px',
  },
  accordionSectionChevron: {
    height: '10px',
    width: 'auto',
    '& path': {
      fill: '#6373A4',
    },
  },
  accordionSectionChevronRotate: {
    transform: 'scaleY(-1) rotate(270deg)',
  },
  accordionSectionChevronActive: {
    '& path': {
      fill: (props: any) => (props.color && props.color) || '#085FE5',
    },
  },
  topDivider: {
    borderTop: '1px solid #D8DCE6',
    position: 'fixed',
    width: '276px',
  },
  bottomDivider: {
    borderBottom: '1px solid #D8DCE6',
  },
  buttonContainer: {
    position: 'relative',
    right: '28px',
  },
  button: {
    border: '1px solid rgba(8,95,229,0.3)',
    marginLeft: '4px',
    marginRight: '4px',
    cursor: 'pointer',
    padding: '3px 10px',
    boxSizing: 'border-box',
    color: '#085FE5',
    fontSize: '10px',
    textAlign: 'center',
    backgroundColor: 'white',
  },
  selectAllButton: {
    height: '20px',
    width: '80px',
  },
  clearButton: {
    height: '20px',
    width: '45px',
  },
  accordionContent: {
    height: 0,
    overflow: 'hidden',
    marginLeft: (props: any) =>
      (props.overrideStylesChildContainer &&
        props.overrideStylesChildContainer.marginLeft) ||
      '0px',
  },
  accordionContentHidden: {
    opacity: '0',
  },
  hidden: {
    display: 'none',
  },
});

export default styleSheet;
